"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _xApiStatementFactory = _interopRequireDefault(require("./xApi/xApiStatementFactory"));
var _TrackingService = _interopRequireDefault(require("./services/TrackingService"));
var _EventService = _interopRequireDefault(require("./services/EventService"));
var _formatName = _interopRequireDefault(require("./utils/formatName"));
var _EventTracker = _interopRequireDefault(require("./event-trackers/EventTracker"));
var _formatter = _interopRequireDefault(require("./lib/formatter"));
var _log = _interopRequireDefault(require("./lib/log"));
var _config = _interopRequireDefault(require("./config/config.json"));
var _configOptions = require("./constants/config-options");
var _defaultConfig = require("./config/default-config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // Copyright 2019 Amplify Inc. All Rights Reserved.
/**
 * @fileoverview The main interface for the lib.
 * @author jgraham@amplify.com (Jessica Graham)
 */
var EXTENSION_UPDATE_ERROR = 'Ampevents tracking service is not started, updating the extension failed';
var AmpEvents = /*#__PURE__*/function () {
  /**
   * Formatter allowList object
   * @typedef {Object} formatterAllowList
   *
   * @property {Array<string>?} keys Top-level keys for values to allow without formatting
   * @property {Object?} actor
   * @property {Array<string>?} actor.keys Keys for values within the event "actor" to allow without formatting
   * @property (Object?) verb
   * @property {Array<string>?} verb.keys Keys for values within the event "verb" to allow without formatting
   * @property (Object?) object
   * @property {Array<string>?} object.keys Keys for values within the event "object" to allow without formatting
   * @property {Object} object.definition
   * @property {Array<string>?} object.definition.keys Keys for values within the event "object.definition" to allow
               without formatting
   * @property (Object?) context
   * @property {Array<string>?} context.keys Keys for values within the event "context" to allow without formatting
   * @property (Object?) context.extensions
   * @property {Array<string>?} context.extensions.keys Keys for values within the event "context.extensions" to allow
   *           without formatting. These need not include the context extension prefix (i.e.
   *           https://api.amplify.com/xapi/extensions/contexts/).
   * @property (Object?) result
   * @property (Object?) result.extensions
   * @property {Array<string>?} result.extensions.keys Keys for values within the event "result.extensions" to allow
   *           without formatting. These need not include the result extension prefix (i.e.
   *           https://api.amplify.com/xapi/extensions/results/).
   */

  /** Initialize the module with the given configuration options.
   *
   * @param {Object} config
   * @param {String} config.appName The name of the app that will send events.
   * @param {String} config.appVersion The version of the app that will send events.
   * @param {String} config.language The language in which xAPI events will be sent (i.e. en-US).
   * @param {String} config.environment The environment in which the app is running (i.e. devci, prod).
   * @param {String} config.userId The id for the logged in user, which will be attached to all events created with
   *                 EventService or TrackingService.
   * @param {String} config.homePage The namespace for the userId which defaults to "https://my.amplify.com" and
   *                 should only be changed if you are not using the Business Key as the userId
   * @param {formatterAllowList} config.formatterAllowList Optional configuration of properties that should be skipped
   *                 when auto-formatting xAPI events.
   * @param {Boolean} config.sendEventsImmediately Whether to send events when they occur, or stash them for
   *                 the next page load.
   */
  function AmpEvents(config) {
    _classCallCheck(this, AmpEvents);
    this.config = Object.assign({}, _defaultConfig.defaultConfig, config);
    this._eventService = new _EventService["default"](this.config);
    this.eventFactory = new _xApiStatementFactory["default"](this.config, this.config[_configOptions.CONFIG_OPTIONS.ENVIRONMENT], this.config[_configOptions.BULK_SEND_OPTIONS.USE_BULK_ON_STASHED_EVENTS], this._eventService);
    this._saveTimestampOffset();
    // Launching events timeout listener if used is using stashed events bulk option
    if (this.config[_configOptions.BULK_SEND_OPTIONS.USE_BULK_ON_STASHED_EVENTS]) {
      this._launchEventsTimeoutListener();
    }
    if (config[_configOptions.CONFIG_OPTIONS.FORMATTER_ALLOW_LIST]) {
      _formatter["default"].setFormattingAllowList(config[_configOptions.CONFIG_OPTIONS.FORMATTER_ALLOW_LIST]);
    }
  }

  /**
   * Set the configured display language for xAPI events.
   *
   * @param {String} language
   */
  _createClass(AmpEvents, [{
    key: "setLanguage",
    value: function setLanguage(language) {
      this.eventFactory.setLanguage(language);
      this._eventService.setLanguage(language);
    }

    /**
     * Set the configured account homePage for xAPI events.
     *
     * @param {String} homePage
     */
  }, {
    key: "setHomePage",
    value: function setHomePage(homePage) {
      this.eventFactory.setHomePage(homePage);
      this._eventService.setHomePage(homePage);
    }

    /**
     * Update formatter allowList configuration. This allowList will be merged with the current allowList in use.
     *
     * @param {formatterAllowList} allowList
     */
  }, {
    key: "updateFormattingAllowList",
    value: function updateFormattingAllowList(allowList) {
      _formatter["default"].updateFormattingAllowList(allowList);
    }

    /**
     * Expose instance of EventService with a getter so that we can prevent its usage if configuration is invalid.
     *
     * @return {EventService?}
     */
  }, {
    key: "eventService",
    get: function get() {
      if (!this.config || !this.config[_configOptions.CONFIG_OPTIONS.APP_NAME] || !this.config[_configOptions.CONFIG_OPTIONS.USER_ID]) {
        throw new Error("AmpEvents must be configured with ".concat(_configOptions.CONFIG_OPTIONS.APP_NAME, " and ") + "".concat(_configOptions.CONFIG_OPTIONS.USER_ID, " options in order to use the EventService"));
      }
      return this._eventService;
    }

    /**
     * Start capturing and sending generic xAPI events.
     *
     * @param {Object?} trackingConfig Optional tracking config options to use, else will use defaults.
     * @param {Boolean} trackingConfig.autoUnload Whether event tracking should automatically stop on window unload.
     *         Default is true.
     * @param {Boolean} trackingConfig.trackAppLoad Whether to track app load events. Default is true.
     * @param {Boolean} trackingConfig.trackAppUnload Whether to track app unload events. Default is true.
     * @param {Boolean} trackingConfig.stashAppUnloadEvent Whether to stash, rather than to immediately send, app
     *         unload events. Stashed events will be sent the next time the user loads the app and AmpEvents is
     *         initialized. Stashing helps prevent events from being lost if the app unloads before an event can be
     *         sent. Default is true.
     * @param {Boolean} trackingConfig.trackPageView Whether to track page view events. Default is true.
     * @param {Boolean} trackingConfig.trackPageClose Whether to track page close events. Default is false.
     * @param {Boolean} trackingConfig.stashFinalPageCloseEvent Whether to stash, rather than to immediately send, the
     *         final page closed event when event tracking is stopped. The stashed event will be sent the next time the
     *         user loads the app and AmpEvents is initialized. This should help ensure that the event will not be lost
     *         if there's not time to send it (i.e. if the app is unloading). Default is true.
     * @param {Boolean} trackingConfig.trackPagesByHashChange Whether to listen for hashchange events on the window
     *         for page view tracking. Appropriate for single-page apps using hash-based routing. This replaces the
     *         default page tracking behavior, which polls for location updates. Default is false.
     * @param {Object?} contextExtensions  Optional context extensions
     * @param {Object?} resultExtensions  Optional context extensions
     * @param {EventTracker[]} customTrackers  Array of optional custom trackers, extending EventTracker
     */
  }, {
    key: "startTrackingEvents",
    value: function startTrackingEvents(trackingConfig, contextExtensions, resultExtensions, customTrackers) {
      if (!this.config || !this.config[_configOptions.CONFIG_OPTIONS.APP_NAME] || !this.config[_configOptions.CONFIG_OPTIONS.USER_ID]) {
        throw new Error("AmpEvents must be configured with ".concat(_configOptions.CONFIG_OPTIONS.APP_NAME, " and ") + "".concat(_configOptions.CONFIG_OPTIONS.USER_ID, " options in order to track events"));
      }
      this.trackingService = new _TrackingService["default"](this._eventService, trackingConfig);
      // Add trackers first so extensions are applied
      if (customTrackers) {
        this.trackingService.addTrackers(customTrackers);
      }
      if (contextExtensions) {
        this.trackingService.addContextExtensions(contextExtensions);
      }
      if (resultExtensions) {
        this.trackingService.addResultExtensions(resultExtensions);
      }
      this.trackingService.start();
    }

    /**
     * Stop capturing and sending generic xAPI events.
     */
  }, {
    key: "stopTrackingEvents",
    value: function stopTrackingEvents() {
      if (this.trackingService) {
        this.trackingService.stop();
      }
    }

    /**
     * Add context extensions to Page and App TrackingEvents.
     *
     * @param {Object} extensions Object of extensions to add.
     * **/
  }, {
    key: "updateTrackingEventContextExtension",
    value: function updateTrackingEventContextExtension(extensions) {
      if (this.trackingService) {
        this.trackingService.addContextExtensions(extensions);
      } else {
        throw new Error(EXTENSION_UPDATE_ERROR);
      }
    }

    /**
     * Add result extensions to Page and App TrackingEvents.
     *
     * @param {Object} extensions Object of extensions to add.
     * **/
  }, {
    key: "updateTrackingEventResultExtension",
    value: function updateTrackingEventResultExtension(extensions) {
      if (this.trackingService) {
        this.trackingService.addResultExtensions(extensions);
      } else {
        throw new Error(EXTENSION_UPDATE_ERROR);
      }
    }

    /**
     * Add custom tracker, must extend EventTracker
     *
     * @param {EventTracker} eventTracker Customer Tracker.
     * **/
  }, {
    key: "addTracker",
    value: function addTracker(eventTracker) {
      if (!(eventTracker instanceof _EventTracker["default"])) {
        throw new Error('Trackers must be of type EventTracker');
      }
      if (this.trackingService && eventTracker) {
        this.trackingService.addTracker(eventTracker);
      } else {
        throw new Error('Updates only, must start tracking service with trackers');
      }
    }

    /**
     * Saves offset between client and server timestamps in local storage
     *
     * **/
  }, {
    key: "_saveTimestampOffset",
    value: function _saveTimestampOffset() {
      var _this = this;
      var environment = this.config[_configOptions.CONFIG_OPTIONS.ENVIRONMENT];
      var serverTimestampUrl = environment ? _config["default"][environment].server_timestamp_url : null;
      _xApiStatementFactory["default"].getServerTimestamp(environment, serverTimestampUrl).then(function (serverTimestamp) {
        try {
          var clientUtcTimestamp = _xApiStatementFactory["default"].getClientTimestamp();
          var offset = serverTimestamp - clientUtcTimestamp;
          var timestampOffsetStorageKey = "timestampOffset-".concat((0, _formatName["default"])(_this.config[_configOptions.CONFIG_OPTIONS.APP_NAME]), "-") + "".concat(_this.config[_configOptions.CONFIG_OPTIONS.USER_ID]);
          localStorage.setItem(timestampOffsetStorageKey, offset.toString());
        } catch (error) {
          _log["default"].error('Error while trying to parse OR set in server timestamp in local storage');
        }
      })["catch"](function () {
        _log["default"].error('Error while trying to calculate difference between server and local timestamp');
      });
    }

    /**
     * Starting timer to send stashed events if timeout reached
     * Timeout is set by user or defaulted using defaultBulkSendConfig
     *
     * **/
  }, {
    key: "_launchEventsTimeoutListener",
    value: function _launchEventsTimeoutListener() {
      var _this2 = this;
      _log["default"].info('Launching stashed events timeout listener');
      var eventsTimeout = this._eventService.bulkSendConfig[_configOptions.BULK_SEND_OPTIONS.BULK_STASHED_EVENTS_TIMEOUT];
      var sessionStorageKey = _configOptions.BULK_SEND_OPTIONS.BULK_SEND_TIMER_SESSION_STORAGE_KEY;
      try {
        setInterval(function () {
          var sessionIterationTime = sessionStorage.getItem(sessionStorageKey);
          var sessionIterationSeconds = Number(sessionIterationTime);
          var nextIterationSecond = (sessionIterationSeconds + 1).toString();

          // if no timer set yet - starting timer
          if (!sessionIterationTime) {
            sessionStorage.setItem(sessionStorageKey, '0');
            return;
          }

          // if the timer reached the timeout limit - events are sent and timeout restarted
          if (sessionIterationSeconds >= eventsTimeout) {
            _this2._eventService.sendStashedEvents();
            sessionStorage.setItem(sessionStorageKey, '0');
            return;
          }

          // updating timer value in session storage into the next second if none of the conditions was met
          sessionStorage.setItem(sessionStorageKey, nextIterationSecond);
        }, 1000);
      } catch (error) {
        _log["default"].error("Error while trying to apply timeout check on stashed events::: ".concat(error));
      }
    }
  }]);
  return AmpEvents;
}();
AmpEvents.OPTIONS = _configOptions.CONFIG_OPTIONS;
AmpEvents.TRACKING_OPTIONS = _configOptions.TRACKING_OPTIONS;
AmpEvents.SEARCH_TRACKING_OPTIONS = _configOptions.SEARCH_TRACKING_OPTIONS;
AmpEvents.ENVIRONMENTS = _configOptions.ENVIRONMENTS;
AmpEvents.BULK_SEND_OPTIONS = _configOptions.BULK_SEND_OPTIONS;
var _default = AmpEvents;
exports["default"] = _default;
module.exports = exports.default;